import axios from 'axios';

const { REACT_APP_BASE_URL } = process.env;

function getToken() {
  return localStorage.getItem('token');
}

async function editPurification(osbInfoId: number, editObj: any) {
  return axios.post(REACT_APP_BASE_URL + 'rest/v1/osb-osb/put/aritma/' + osbInfoId, editObj, { params: { token: getToken() } });
}

async function addPurification(addObj: any) {
  return axios.post(REACT_APP_BASE_URL + 'rest/v1/osb-osb/aritma/', addObj, { params: { token: getToken() } });
}

async function deletePurification(osbInfoId: number) {
  const body = { active: false }

  return axios.post(REACT_APP_BASE_URL + 'rest/v1/osb-osb/put/aritma/' + osbInfoId, body, { params: { token: getToken() } });
}

export const OsbInfoRestApi = {
  editPurification,
  addPurification,
  deletePurification,
};
